import * as React from 'react';
import clsx from 'clsx';
import styles from './visually-hidden.module.css';

export type VisuallyHiddenElement = 'span' | 'div' | 'p' | 'li' | 'caption' | 'legend';

export interface VisuallyHiddenProps extends React.HTMLAttributes<HTMLElement> {
    as?: VisuallyHiddenElement;
    children?: React.ReactNode;
    className?: string;
    testId?: string;
}

export const VisuallyHidden: React.FC<VisuallyHiddenProps> = (props) => {
    const { as: Element = 'span', className, children, testId, ...rest } = props;

    return (
        <Element className={clsx(styles['visually-hidden'], className)} data-testid={testId} {...rest}>
            {children}
        </Element>
    );
};
